import { useEffect, useRef } from 'react';
import { useAuth } from 'contexts/AuthContext';

export const useCustomerFormPopulation = (isAuthenticated, setFieldValue) => {
  const { addressData, getAddressData } = useAuth();
  const hasPopulatedRef = useRef(false);

  useEffect(() => {
    // Only run once when user is authenticated and form is ready
    if (!isAuthenticated || hasPopulatedRef.current || !setFieldValue) {
      return;
    }

    const populateForm = async () => {
      try {
        const freshAddressData = await getAddressData();

        if (freshAddressData) {
          const customerData = {
            firstName: freshAddressData.firstName || '',
            lastName: freshAddressData.lastName || '',
            businessName: freshAddressData.businessName || '',
            phone: freshAddressData.phone || '',
            email: freshAddressData.email || '',
            address1: freshAddressData.address1 || '',
            address2: freshAddressData.address2 || '',
            city: freshAddressData.city || '',
            state: freshAddressData.state || '',
            zip: freshAddressData.zipCode || '', // Note: addressData uses zipCode, form uses zip
            userId: freshAddressData.labAccountNumber || '', // Note: addressData uses labAccountNumber, form uses userId
            country: 'US', // Add country field with default 'US'
          };

          setFieldValue('customer', customerData);
        }
      } catch (error) {
        console.warn('[Address] Failed to fetch fresh address data:', error);
        // Fallback to cached data if fresh fetch fails
        if (addressData) {
          console.log('[Address] Using cached address data as fallback');
          const customerData = {
            firstName: addressData.firstName || '',
            lastName: addressData.lastName || '',
            businessName: addressData.businessName || '',
            phone: addressData.phone || '',
            email: addressData.email || '',
            address1: addressData.address1 || '',
            address2: addressData.address2 || '',
            city: addressData.city || '',
            state: addressData.state || '',
            zip: addressData.zipCode || '', // Note: addressData uses zipCode, form uses zip
            userId: addressData.labAccountNumber || '', // Note: addressData uses labAccountNumber, form uses userId
            country: 'US', // Add country field with default 'US'
          };
          setFieldValue('customer', customerData);
        }
      }
    };

    populateForm();
  }, [isAuthenticated, setFieldValue]); // Only depend on authentication status and setFieldValue
};
